/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refineexampleremovebackgroundprompt4Inputs */

const en_refineexampleremovebackgroundprompt4 = /** @type {(inputs: Refineexampleremovebackgroundprompt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove the background and make it transparent`)
};

const de_refineexampleremovebackgroundprompt4 = /** @type {(inputs: Refineexampleremovebackgroundprompt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entferne den Hintergrund und mache ihn transparent`)
};

/**
* | output |
* | --- |
* | "Remove the background and make it transparent" |
*
* @param {Refineexampleremovebackgroundprompt4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refineexampleremovebackgroundprompt4 = /** @type {((inputs?: Refineexampleremovebackgroundprompt4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refineexampleremovebackgroundprompt4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refineexampleremovebackgroundprompt4(inputs)
	return de_refineexampleremovebackgroundprompt4(inputs)
});
export { refineexampleremovebackgroundprompt4 as "refineExampleRemoveBackgroundPrompt" }